import initWeb3 from "./initWeb3"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import useAllowance from "./useAllowance"
const useMintUserCopyright = () => {
    const allowance = useAllowance()
    useEffect(() => {
        initWeb3()
    }, [])
    const { address } = useSelector(state => state.home)
    const mintUserCopyright = async (...arg) => {
        try {
         
            await allowance()
            let mint = window.SBNContract.methods.mintUserCopyright(...arg)
            console.log('mint:', mint)
            // 预估 gas
            const gasBase = await mint.estimateGas({ from: address });
            console.log('当前需要的 gas:', gasBase);
            const gasPrice = gasBase * 352500
            console.log('当前需要的 gas增幅:', gasPrice);
            const result = await mint.send({ from: address,gasPrice  })
            
            return result
            
        } catch (error) {
            console.log('mintUserCopyright error:',error)
        }
    }
    return mintUserCopyright
}

export default useMintUserCopyright